import { isAudio, isText, isTransition } from '~/Util/assets'

export const isAvailableAttachTransition = asset => {
  if (!asset) return false
  return !(isText(asset.type)
  || isTransition(asset.type)
  || isAudio(asset.filetype))
}
